module.exports = __webpack_public_path__ + "static/media/clip.f2515f87.svg";